module.exports = __webpack_public_path__ + "img/rubin-img-01.24345d91.jpg";